import { IconSpec } from "@impero-com/common/componentTypes/icon";
import { renderMarkdown, Svg } from "@impero-com/ui";
import remove from "@impero-com/ui/img/remove.svg";
import useCollapse from "react-collapsed";

import lightBulbShine from "img/light-bulb-shine.svg";

import * as theme from "./theme.css";

function InfoBox(props: InfoBoxProps) {
    const { visible, text, icon, onClose } = props;
    const { getCollapseProps } = useCollapse({ isOpen: visible });

    let closeButton;
    if (onClose) {
        closeButton = (
            <div>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClose();
                    }}
                >
                    <Svg src={remove} className={theme.closeImage} />
                </a>
            </div>
        );
    } else {
        closeButton = null;
    }
    const iconSrc: string = icon ? icon.svg : lightBulbShine;

    return (
        <div {...getCollapseProps()}>
            <div className={theme.infoBox}>
                <div>
                    <Svg src={iconSrc} className={theme.lightBulb} />
                </div>
                <div className={theme.infoBoxContent}>
                    {renderMarkdown(text)}
                </div>
                {closeButton}
            </div>
        </div>
    );
}

interface InfoBoxProps {
    visible: boolean;
    text: string;
    icon?: IconSpec;
    onClose?: () => void;
}

export { InfoBox, type InfoBoxProps };
